import {createApp, h, provide} from 'vue';
import {router} from '@/router';
import App from "@/App.vue";
import {BootstrapVue3, BToastPlugin} from 'bootstrap-vue-3'
import VueSelect from 'vue3-select2-component'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import DatePicker from 'vue3-datepicker'
import VueApexCharts from "vue3-apexcharts"
import VCalendar from 'v-calendar';
import pinia from '@/plugins/pinia';

/********* components **********/
import Breadcrumb from '@/components/breadcrumb/breadcrumb.vue'
import CageBreadcrumb from '@/components/breadcrumb/cage-breadcrumb.vue'
import CageTabset from '@/components/cage-tabset.vue'
import CoachTabset from '@/components/coach-tabset.vue'
import CoachesFilterSidebar from '@/components/coaches-filter-sidebar.vue'
import Loader from '@/components/loader.vue'

/********* Layouts components **********/
import HeaderInterface from '@/interface/layouts/header.vue'
import UserHeaderInterface from '@/interface/layouts/user-header.vue'
import BlogSidebar from '@/views/layouts/blog-sidebar.vue'
import UserTabsetInterface from '@/interface/layouts/user-tabset.vue'
import Settings_Sidebar from '@/interface/layouts/settings-sidebar.vue'
import FooterInterface from '@/interface/layouts/footer.vue'
import BookingTabset from '@/views/layouts/booking-tabset.vue'
import CoachesSidebar from '@/views/layouts/coaches-sidebar.vue'
import HeaderMenuInterface from '@/interface/layouts/header-menu.vue'
import DetailSidebar from '@/interface/pages/tournament/details/detail-sidebar.vue'
import TournamentTournamentRanker from '@/interface/pages/tournament/details/tournament-ranker.vue'
import VenueSidebar from '@/views/layouts/venue-sidebar.vue'
import CoachSettingsTabset from '@/views/layouts/coach-settings-tabset.vue'
import CoachDashboardMenu from '@/views/layouts/coach-dashboard-menu.vue'
import AllCourtTabset from '@/views/layouts/all-court-tabset.vue'
import CoachBookingTabset from '@/views/layouts/coach-booking-tabset.vue'

/********* Pages components **********/
import HomeBannerInterface from '@/interface/pages/home/home-banner.vue'
import HomeVenues from '@/views/pages/home/home-venues.vue'
import HomeServiceInterface from '@/interface/pages/home/home-service.vue'
import HomeCoachesInterface from '@/interface/pages/home/home-coaches.vue'
import HomeGroupInterface from '@/interface/pages/home/home-group.vue'
import HomeExcellence from '@/views/pages/home/home-excellence.vue'
import HomeTestimonialsInterface from '@/interface/pages/home/home-testimonials.vue'
import HomeSlide from '@/interface/pages/home/home-slide.vue'
import HomePlansInterface from '@/interface/pages/home/home-plans.vue'
import HomeNews from '@/views/pages/home/home-news.vue'
import Allservices from '@/views/pages/pages/services/allservices.vue'
import Coaching from '@/views/pages/pages/services/coaching.vue'
import Lesson from '@/views/pages/pages/services/lesson.vue'
import Coaches from '@/views/pages/pages/services/coaches.vue'
import AboutFeatures from '@/interface/pages/pages/about-us/about-features.vue'
import AboutLetter from '@/views/pages/pages/about-us/about-letter.vue'
import AboutNews from '@/interface/pages/pages/about-us/about-news.vue'
import AboutPlans from '@/views/pages/pages/about-us/about-plans.vue'
import AboutTeam from '@/interface/pages/pages/about-us/about-team.vue'
import AboutTestimonials from '@/interface/pages/pages/about-us/about-testimonials.vue'
import AboutVision from '@/interface/pages/pages/about-us/about-vision.vue'
import AboutCompany from '@/interface/pages/pages/about-us/about-company.vue'
import AppointmentInterface from '@/interface/pages/user/user-dashboard/appointment.vue'
import Booking_Coaching from '@/views/pages/user/user-dashboard/booking-coaching.vue'
import MyBooking_CourtInterface from '@/interface/pages/user/user-dashboard/mybooking-court.vue'
import Recent_Coaching from '@/views/pages/user/user-dashboard/recent-coaching.vue'
import StatisticsInterface from '@/interface/pages/user/user-dashboard/statistics.vue'
import Your_Wallet from '@/views/pages/user/user-dashboard/your-wallet.vue'
import TournamentTable from '@/interface/pages/user/user-tournament/tournament-table.vue'
import MatchTable from '@/interface/pages/user/user-match/match-table.vue'
import RankTable from '@/interface/pages/tournament/rank-table.vue'
import BookingCoaches from '@/views/pages/user/user-bookings/booking-coaches.vue'
import CompleteCoaches from '@/views/pages/user/user-complete/complete-coaches.vue'
import CompleteCourt from '@/views/pages/user/user-complete/complete-court.vue'
import OngoingCourt from '@/views/pages/user/user-ongoing/ongoing-court.vue'
import CancelledCoaches from '@/views/pages/user/user-cancelled/cancelled-coaches.vue'
import CancelledCourt from '@/views/pages/user/user-cancelled/cancelled-court.vue'
import SimilarCoaches from '@/views/pages/coaches/similar-coaches.vue'
import VenueCarousel from '@/views/pages/coaches/venue/venue-carousel.vue'
import GalleryCarousel from '@/views/pages/coaches/venue/gallery-carousel.vue'
import VenueDetailsCarousel from '@/views/pages/coaches/venue/venue-details-carousel.vue'
import VenueGallery from '@/views/pages/coaches/venue/venue-gallery.vue'
import CoachBookingCourt from '@/views/pages/coaches/coach-dashboard/coach-booking-court.vue'
import CoachBookingCoaching from '@/views/pages/coaches/coach-dashboard/coach-booking-coaching.vue'
import CoachMyBookingCourt from '@/views/pages/coaches/coach-dashboard/coach-mybooking-court.vue'
import CoachMyBookingCoaching from '@/views/pages/coaches/coach-dashboard/coach-mybooking-coaching.vue'
import CoachRequestCount from '@/views/pages/coaches/coach-request/coach-request-count.vue'
import CoachRequestCoaching from '@/views/pages/coaches/coach-request/coach-request-coaching.vue'
import SettingsTabset from '@/views/pages/coaches/profile-setting/settings-tabset.vue'
import UpcomingCourt from '@/views/pages/coaches/coach-booking/upcoming-court.vue'
import UpcomingCoach from '@/views/pages/coaches/coach-booking/upcoming-coach.vue'
import CompletedCourt from '@/views/pages/coaches/coach-booking/completed-court.vue'
import CompletedCoach from '@/views/pages/coaches/coach-booking/completed-coach.vue'
import BookingCancelCourt from '@/views/pages/coaches/coach-booking/cancelled-court.vue'
import BookingCancelCoach from '@/views/pages/coaches/coach-booking/cancelled-coach.vue'
import CoachDetailImage from '@/views/pages/coaches/coach-detail-image.vue'


/********* Modal components **********/
import UserWalletModal from '@/components/modal/user-wallet-modal.vue'
import UserDashboardModal from '@/components/modal/user-dashboard-modal.vue'
import UserBookingModal from '@/components/modal/user-booking-modal.vue'
import UserCompleteModal from '@/components/modal/user-complete-modal.vue'
import CarouselModal from '@/components/modal/carousel-modal.vue'
import UserCancelledModal from '@/components/modal/user-cancelled-modal.vue'
import UserOngoingModal from '@/components/modal/user-ongoing-modal.vue'
import CageCheckoutModal from '@/components/modal/cage-checkout-modal.vue'
import CoachPaymentModal from '@/components/modal/coach-payment-modal.vue'
import CoachRequestModal from '@/components/modal/coach-request-modal.vue'
import CompleteCourtModal from '@/components/modal/complete-court-modal.vue'
import CompleteCoachesModal from '@/components/modal/complete-coaches-modal.vue'
import BookingCourtModal from '@/components/modal/booking-court-modal.vue'
import BookingCoachesModal from '@/components/modal/booking-coaches-modal.vue'
import OngoingCourtModal from '@/components/modal/ongoing-court-modal.vue'
import OngoingCoachesModal from '@/components/modal/ongoing-coaches-modal.vue'
import CoachWalletModal from '@/components/modal/coach-wallet-modal.vue'
import ProfileOthersettingModal from '@/components/modal/profile-othersetting-modal.vue'
import CoachBookingModal from '@/components/modal/coach-booking-modal.vue'
import BookingCompletedModal from '@/components/modal/booking-completed-modal.vue'
import BoockingCancelModal from '@/components/modal/booking-cancelled-modal.vue'
import CoachDetailModal from '@/components/modal/coach-detail-modal.vue'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@/assets/css/feather.css';
import '@/assets/css/style.css';
import {DefaultApolloClient} from '@vue/apollo-composable';
import {apolloClient} from './graphql/apollo-client.ts';

/* Table components */
import TourPlayerTable from '@/interface/pages/tournament/inc/tourplayer-table.vue'
import TourMatchTable from '@/interface/pages/tournament/inc/tourmatch-table.vue'
import TourTeamTable from '@/interface/pages/tournament/inc/tourteam-table.vue'

/* inc page */
import MatchOngoing from '@/interface/pages/tournament/inc/matches-ongoing.vue'

const app = createApp({
    setup() {
        provide(DefaultApolloClient, apolloClient);
    },
    render: () => h(App),
});

// Khởi tạo Firebase

/********* components **********/
app.component('breadcrumb', Breadcrumb)
app.component('cage-breadcrumb', CageBreadcrumb)
app.component('cage-tabset', CageTabset)
app.component('coach-tabset', CoachTabset)
app.component('coaches-filter-sidebar', CoachesFilterSidebar)
app.component('loader', Loader)

/********* Layouts components **********/
app.component('layouts-header', HeaderInterface)
app.component('user-header', UserHeaderInterface)
app.component('blog-sidebar', BlogSidebar)
app.component('user-tabset', UserTabsetInterface)
app.component('settings-sidebar', Settings_Sidebar)
app.component('booking-tabset', BookingTabset)
app.component('header-menu', HeaderMenuInterface)
app.component('layout-footer', FooterInterface)
app.component('coaches-sidebar', CoachesSidebar)
app.component('detail-sidebar', DetailSidebar)
app.component('tournament-ranker', TournamentTournamentRanker)
app.component('venue-sidebar', VenueSidebar)
app.component('coach-settings-tabset', CoachSettingsTabset)
app.component('coach-dashboard-menu', CoachDashboardMenu)
app.component('all-court-tabset', AllCourtTabset)
app.component('coach-booking-tabset', CoachBookingTabset)


/********* Pages components **********/
app.component('home-banner', HomeBannerInterface)
app.component('home-venues', HomeVenues)
app.component('home-service', HomeServiceInterface)
app.component('home-coaches', HomeCoachesInterface)
app.component('home-group', HomeGroupInterface)
app.component('home-excellence', HomeExcellence)
app.component('home-testimonials', HomeTestimonialsInterface)
app.component('home-slide', HomeSlide)
app.component('home-plans', HomePlansInterface)
app.component('home-news', HomeNews)
app.component('allservices', Allservices)
app.component('coaching', Coaching)
app.component('lesson', Lesson)
app.component('coaches', Coaches)
app.component('about-features', AboutFeatures)
app.component('about-letter', AboutLetter)
app.component('about-news', AboutNews)
app.component('about-plans', AboutPlans)
app.component('about-team', AboutTeam)
app.component('about-testimonials', AboutTestimonials)
app.component('about-vision', AboutVision)
app.component('about-company', AboutCompany)
app.component('appointment', AppointmentInterface)
app.component('booking-coaching', Booking_Coaching)
app.component('mybooking-court', MyBooking_CourtInterface)
app.component('match-table', MatchTable)
app.component('rank-table', RankTable)
app.component('recent-coaching', Recent_Coaching)
app.component('statistics', StatisticsInterface)
app.component('your-wallet', Your_Wallet)
app.component('tournament-table', TournamentTable)
app.component('booking-coaches', BookingCoaches)
app.component('complete-coaches', CompleteCoaches)
app.component('complete-court', CompleteCourt)
app.component('ongoing-court', OngoingCourt)
app.component('cancelled-coaches', CancelledCoaches)
app.component('cancelled-court', CancelledCourt)
app.component('similar-coaches', SimilarCoaches)
app.component('venue-carousel', VenueCarousel)
app.component('gallery-carousel', GalleryCarousel)
app.component('venue-details-carousel', VenueDetailsCarousel)
app.component('venue-gallery', VenueGallery)
app.component('coach-booking-court', CoachBookingCourt)
app.component('coach-booking-coaching', CoachBookingCoaching)
app.component('coach-mybooking-court', CoachMyBookingCourt)
app.component('coach-mybooking-coaching', CoachMyBookingCoaching)
app.component('coach-request-count', CoachRequestCount)
app.component('coach-request-coaching', CoachRequestCoaching)
app.component('settings-tabset', SettingsTabset)
app.component('upcoming-coach', UpcomingCoach)
app.component('upcoming-court', UpcomingCourt)
app.component('completed-court', CompletedCourt)
app.component('completed-coach', CompletedCoach)
app.component('booking-cancelled-court', BookingCancelCourt)
app.component('booking-cancelled-coach', BookingCancelCoach)
app.component('coach-detail-image', CoachDetailImage)

/* Table components */
app.component('tour-player-table', TourPlayerTable)
app.component('tour-match-table', TourMatchTable)
app.component('tour-team-table', TourTeamTable)

/* inc page */
app.component('match-ongoing', MatchOngoing)

/********* Modal components **********/
app.component('user-wallet-modal', UserWalletModal)
app.component('user-dashboard-modal', UserDashboardModal)
app.component('user-booking-modal', UserBookingModal)
app.component('user-complete-modal', UserCompleteModal)
app.component('carousel-modal', CarouselModal)
app.component('user-cancelled-modal', UserCancelledModal)
app.component('user-ongoing-modal', UserOngoingModal)
app.component('cage-checkout-modal', CageCheckoutModal)
app.component('coach-payment-modal', CoachPaymentModal)
app.component('coach-request-modal', CoachRequestModal)
app.component('complete-court-modal', CompleteCourtModal)
app.component('complete-coaches-modal', CompleteCoachesModal)
app.component('booking-court-modal', BookingCourtModal)
app.component('booking-coaches-modal', BookingCoachesModal)
app.component('ongoing-court-modal', OngoingCourtModal)
app.component('ongoing-coaches-modal', OngoingCoachesModal)
app.component('coach-wallet-modal', CoachWalletModal)
app.component('profile-othersetting-modal', ProfileOthersettingModal)
app.component('coach-booking-modal', CoachBookingModal)
app.component('booking-completed-modal', BookingCompletedModal)
app.component('booking-cancelled-modal', BoockingCancelModal)
app.component('coach-detail-modal', CoachDetailModal)


app.component('vue-select', VueSelect)
app.component('datepicker', DatePicker)
    .use(Antd)
    .use(BootstrapVue3)
    .use(BToastPlugin)
app.use(VCalendar, {})
app.use(VueApexCharts)
app.use(pinia)
app.use(router);
app.mount('#app');
